// Text for the 'space' world: its name on the map, the level titles and the comic word in the scene, per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Rumkaniner',
    scene: { hop: 'HOP!' },
    levels: {
      'moon-hop': { title: 'Månehop' },
      'rocket': { title: 'Raketten' },
      'moon-pulls': { title: 'Månen trækker' },
      'asteroid': { title: 'Asteroiden' },
      'aim-up': { title: 'Sigt opad' },
      'not-too-close': { title: 'Ikke for tæt' },
      'no-air': { title: 'Ingen luft' },
      'around-the-planet': { title: 'Rundt om planeten' },
      'moon-trampoline': { title: 'Månetrampolin' },
      'seesaw': { title: 'Vippen' },
      'button': { title: 'Knappen' },
      'over-the-wall': { title: 'Over muren' },
      'two-rockets': { title: 'To raketter' },
      'hop-and-hatch': { title: 'Hop og luge' },
      'master': { title: 'Mester' },
    },
  },
  en: {
    name: 'Space bunnies',
    scene: { hop: 'BOING!' },
    levels: {
      'moon-hop': { title: 'Moon hop' },
      'rocket': { title: 'The rocket' },
      'moon-pulls': { title: 'The moon pulls' },
      'asteroid': { title: 'The asteroid' },
      'aim-up': { title: 'Aim up' },
      'not-too-close': { title: 'Not too close' },
      'no-air': { title: 'No air' },
      'around-the-planet': { title: 'Round the planet' },
      'moon-trampoline': { title: 'Moon trampoline' },
      'seesaw': { title: 'The seesaw' },
      'button': { title: 'The button' },
      'over-the-wall': { title: 'Over the wall' },
      'two-rockets': { title: 'Two rockets' },
      'hop-and-hatch': { title: 'Hop and hatch' },
      'master': { title: 'Master' },
    },
  },
});
